import React, { useState } from 'react'
import { Panel, Row, Col, SelectPicker, Icon, IconButton, DatePicker, Table } from 'rsuite'
import { useForm } from 'react-hook-form'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, LOCAL_DAY_TH, REQUEST_DATE_FORMAT } from '../../constants/date'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { doneLoading, startLoading } from '../../utils/loading'
import { calDepositReport, downloadDepositReportPdf } from '../../redux/actions/accountingReport'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { downloadFile } from '../../utils/fileUtil'

export default function DepositReportWidget({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [category, setCategory] = useState()
  const [accountId, setAccountId] = useState()
  const [searchSchema, setSearchSchema] = useState()
  const [selectHeader, setSelectHeader] = useState()
  const [period, setPeriod] = useState()
  const projectCode = sessionStorage.getItem('projectCode')
  const fs = localStorage.getItem('fontSize')
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }

  const handleSelectAcc = (data) => {
    // console.log('handleSelectAcc ', id)
    var header = ` ${data.accountNo} ${data.accountName} (${data.accountType})`
    setSelectHeader(header)
    setAccountId(data.id)

    const request = {
      id: data.id,
    }

    handleGetSchema(request)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await calDepositReport(projectCode, request)
      // console.log('schemaaaa => ', _schema.model)
      setSearchSchema(response.model)
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = () => {
    console.log('handleSearch')
    // const request = {
    //   id: accountId,
    //   period: period,
    //   // category: category,
    //   // startDate: startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null,
    //   // endDate: endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null,
    // }

    var request = {
      id: accountId,
      startDate: startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null,
      endDate: endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null,
    }
    if (period) {
      request.period = period
    }

    handleGetSchema(request)
  }

  const handleCancel = () => {
    console.log('handleCancel')
    const request = {
      id: accountId,
    }

    setStartDate(null)
    setEndDate(null)
    setPeriod(null)
    setCategory()

    handleGetSchema(request)
  }

  const handleOnExportPdf = async (data) => {
    setIsLoading(true)
    startLoading()
    try {
      const _startDate = startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : ''
      const _endDate = endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : ''
      const file = await downloadDepositReportPdf(
        projectCode,
        accountId,
        period,
        _startDate,
        _endDate
      )
      // console.log('file ', file)
      if (file) {
        downloadFile(file, `รายการเงินฝาก_${projectCode}.pdf`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={formSchema.header || ' '} bordered expanded>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        <Row style={{ marginTop: 30 }}>
          <Col lg={2} md={2} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <Table
              wordWrap
              minHeight={100}
              autoHeight
              loading={isLoading}
              data={schema.datas.values || []}
              style={{ marginTop: 30 }}
            >
              <Column width={180}>
                <HeaderCell style={styleHeaderCell}>เลขที่บัญชี</HeaderCell>
                <Cell dataKey="accountNo" />
              </Column>

              <Column width={280} minWidth={280} flexGrow={1}>
                <HeaderCell style={styleHeaderCell}>ชื่อบัญชี</HeaderCell>
                <Cell dataKey="accountName" />
              </Column>

              <Column width={150} align="center">
                <HeaderCell style={styleHeaderCell}>ประเภทบัญชี</HeaderCell>
                <Cell dataKey="accountType" />
              </Column>

              <Column width={180} align="right">
                <HeaderCell style={styleHeaderCell}>คงเหลือ (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return budgetFormat(rowData.balance || 0)
                  }}
                </Cell>
              </Column>

              <Column width={120} align="center">
                <HeaderCell style={styleHeaderCell}></HeaderCell>
                <Cell style={{ textAlign: 'center' }}>
                  {(rowData) => {
                    return (
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon appearance="ghost" icon="eye" className="bt-gost-icon-radius" />
                        }
                        onClick={() => {
                          handleSelectAcc(rowData)
                        }}
                      >
                        แสดง
                      </IconButton>
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Col>
          <Col lg={2} md={2} sm={24} xs={24}></Col>
        </Row>

        {searchSchema && (
          <>
            <hr />
            <Panel header={selectHeader} collapsible bodyFill defaultExpanded>
              {searchSchema.searchForm && (
                <>
                  <br />

                  {searchSchema.searchForm.period && (
                    <Row style={{ marginTop: 10 }}>
                      <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        <b>{searchSchema.searchForm.period.label} : </b>
                      </Col>
                      <Col lg={6} md={6} sm={24} xs={24}>
                        <SelectPicker
                          searchable={false}
                          data={searchSchema.searchForm.period.options}
                          value={period}
                          block
                          placeholder={searchSchema?.searchForm?.period?.placeholder || ''}
                          onChange={(value) => {
                            setPeriod(value)
                          }}
                        />
                      </Col>
                    </Row>
                  )}

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {searchSchema.searchForm.startDate.label}
                    </Col>

                    <Col lg={6} md={6} sm={24} xs={24}>
                      <DatePickerCustom
                        value={startDate}
                        onChange={(value) => {
                          setStartDate(value)
                        }}
                        placement="auto"
                        disabledDate={(date) =>
                          endDate && moment(endDate).isBefore(date, new Date())
                        }
                      />
                    </Col>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {searchSchema.searchForm.endDate.label}
                    </Col>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <DatePickerCustom
                        value={endDate}
                        onChange={(value) => {
                          setEndDate(value)
                        }}
                        placement="auto"
                        disabledDate={(date) =>
                          startDate && moment(startDate).isAfter(date, new Date())
                        }
                      />
                    </Col>
                    <Col lg={4} md={4} sm={24} xs={24}></Col>
                  </Row>

                  {/* <Row style={{ marginTop: 10 }}>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      {searchSchema.searchForm.category.label}
                    </Col>
                    <Col lg={6} md={6} sm={24} xs={24}>
                      <SelectPicker
                        searchable={false}
                        value={category}
                        data={searchSchema.searchForm.category.options}
                        block
                        onChange={value => {
                          setCategory(value)
                        }}
                      />
                    </Col>
                  </Row> */}

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
                    <Col lg={20} md={20} sm={24} xs={24}>
                      <SearchButton disabled={false} onClick={handleSearch}>
                        ค้นหา
                      </SearchButton>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
                        style={{ marginTop: -10 }}
                        onClick={handleOnExportPdf}
                      >
                        Export to PDF
                      </IconButton>
                      {`  `}
                      <CancelButton disabled={false} onClick={handleCancel}>
                        ยกเลิก
                      </CancelButton>
                    </Col>
                  </Row>
                </>
              )}

              <Table
                wordWrap
                minHeight={400}
                autoHeight
                loading={isLoading}
                data={searchSchema?.datas?.values || []}
                style={{ marginTop: 10 }}
                headerHeight={fs < 16 ? 60 : fs <= 18 ? 75 : 80}
              >
                <Column width={90} align="center">
                  <HeaderCell>ลำดับ</HeaderCell>
                  <Cell dataKey="rowNumber" />
                  {/* <Cell>
                    {(_, index) => {
                      return index + 1
                    }}
                  </Cell> */}
                </Column>

                <Column width={180} align="center">
                  <HeaderCell style={styleHeaderCell}>วันที่เอกสาร</HeaderCell>
                  <Cell dataKey="docDate" />
                </Column>

                <Column width={180}>
                  <HeaderCell style={styleHeaderCell}>เลขที่ใบสำคัญ</HeaderCell>
                  <Cell dataKey="docNumber" />
                </Column>

                <Column width={280} minWidth={280} flexGrow={1}>
                  <HeaderCell style={styleHeaderCell}>รายการ</HeaderCell>
                  <Cell dataKey="detail" />
                </Column>

                <Column width={150} align="right">
                  <HeaderCell style={styleHeaderCell}>ฝาก (บาท)</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.deposit ? budgetFormat(rowData.deposit) : '-'
                    }}
                  </Cell>
                </Column>
                <Column width={150} align="right">
                  <HeaderCell style={styleHeaderCell}>ถอน (บาท)</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      return rowData.withdraw ? budgetFormat(rowData.withdraw) : '-'
                    }}
                  </Cell>
                </Column>
                <Column width={120}>
                  <HeaderCell style={styleHeaderCell}>คงเหลือ (บาท)</HeaderCell>
                  <Cell style={{ textAlign: 'right' }}>
                    {(rowData) => {
                      return budgetFormat(rowData.balance || 0)
                    }}
                  </Cell>
                </Column>
              </Table>
            </Panel>
          </>
        )}
      </Panel>
    </>
  )
}
